import WhiteDonnonsLogo from '@/core/components/WhiteDonnonsLogo/WhiteDonnonsLogo';

export default WhiteDonnonsLogo;
